import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getPageContent } from "../../utils";
import { selectPropertyData, selectPropertyStatus, selectPropertyError, initializeAsync } from "./propertySlice";
import { useMediaQuery } from "react-responsive";
import Streetview from "react-google-streetview";
import { useParams } from "react-router-dom";
import {
    Box,
    AppBar,
    Toolbar,
    Stack,
    Tab,
    Button,
    Paper,
    Typography,
    Card,
    CardHeader,
    CardContent,
    Chip,
    Divider,
    Alert,
    Snackbar,
} from "@mui/material";
import BuildIcon from "@mui/icons-material/Build";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Grid from "@mui/material/Unstable_Grid2";
import GoogleAutoComplete from "../../components/GoogleAutoComplete";
import "./style.css";
import { config, styles } from "../../style";
import { styled } from "@mui/material/styles";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { ImageSlider } from "../../components/ImageSlider";
import CloseIcon from "@mui/icons-material/Close";

import MapsHomeWorkIcon from "@mui/icons-material/MapsHomeWork";
import { ReactComponent as BedIcon } from "../../assets/svgs/bed.svg";
import { ReactComponent as BathIcon } from "../../assets/svgs/bath.svg";
import { ReactComponent as SquareIcon } from "../../assets/svgs/square.svg";
import { ReactComponent as CurrancyIcon } from "../../assets/svgs/currancy.svg";
import { ReactComponent as UserCheckIcon } from "../../assets/svgs/user-check.svg";
import { ReactComponent as StreetViewIcon } from "../../assets/svgs/street-view.svg";
import { ReactComponent as VideoIcon } from "../../assets/svgs/video.svg";
import { ReactComponent as VirtualTourcon } from "../../assets/svgs/virtual-tour.svg";
import { ReactComponent as FloorPlanIcon } from "../../assets/svgs/floor-plan.svg";
import { ReactComponent as PhotosIcon } from "../../assets/svgs/photos.svg";
import { ReactComponent as RentIcon } from "../../assets/svgs/rent-icon.svg";
import { ReactComponent as LockIcon } from "../../assets/svgs/lock-02.svg";
import { InnerCard } from "../../components/InnerCard";
import Map from "../../components/Map";
import { Modal } from "../../components/Modal";
import { DataTable } from "../../components/DataTable";
import { formatDateTimeRange } from "../../utils";
import TurnedInNotIcon from "@mui/icons-material/TurnedInNot";
import { SelfTourWaitlist } from "../../components/SelfTourWaitlist";

const AntTab = styled((props) => <Tab disableRipple {...props} />)(({ theme }) => ({
    textTransform: "none",
    minWidth: 0,
    zIndex: 1,
    [theme.breakpoints.up("sm")]: {
        minWidth: 0,
    },
    fontWeight: "600",
    marginRight: theme.spacing(1),
    color: "#1F4E66",
    "&:hover": {
        color: config.primaryColor,
        opacity: 1,
    },
    "&.Mui-selected": {
        color: config.primaryColor,
        fontWeight: "600",
    },
    "&.MuiTabs-indicator": {
        display: "none",
        //backgroundColor: "orange"
    },

    "&.Mui-focusVisible": {
        backgroundColor: config.primaryColor,
    },
}));

const Property = () => {
    const data = useSelector(selectPropertyData);
    const status = useSelector(selectPropertyStatus);
    const error = useSelector(selectPropertyError);

    const [openToster, setOpenToster] = React.useState(false);
    const [tosterVariant, setTosterVariant] = useState("error");
    const [tosterMessage, setTosterMessage] = useState("");
    const dispatch = useDispatch();
    let { recordId } = useParams();
    const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        maximumFractionDigits: 0,
    });
    const numberFormatter = new Intl.NumberFormat("en-US", {
        maximumFractionDigits: 0,
    });

    const floatFormatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
    });

    const listingData = useSelector((state) => {
        let data = state.property.data[recordId];
        return data;
    });

    const [mapref, setMapRef] = React.useState(null);
    const [zoom, setZoom] = useState(12);
    const [location, setLocation] = useState();
    const [coordinates, setCordinaties] = useState({ lat: 43.45, lng: -80.49 });

    const [selectedTab, setSelectedTab] = React.useState("Overview");
    const [selectedProfileTab, setSelectedProfileTab] = React.useState("Photos");
    const [photosModal, setPhotosModal] = React.useState(false);
    const [mapObject, setMapObject] = React.useState("");
    const isDesktop = useMediaQuery({ minWidth: 1180 });
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1179 });
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const isPortrait = useMediaQuery({ orientation: "landscape" });
    const [currentSelectedModalImage, setCurrentSelectedModalImage] = React.useState(0);
    const [slider, setSlider] = React.useState("");
    const [openSelfTour, setOpenSelfTour] = React.useState(false);

    const imageSliderRef = useRef();

    useEffect(() => {
        if (status === "idle") {
            dispatch(initializeAsync({ recordId }));
        }
    }, [recordId, status, dispatch]);

    const handleSelectedLocation = (result) => {
        localStorage.setItem("lastLocation", JSON.stringify(result));
        setLocation(result);
        setCordinaties(result.geometry.location);
    };

    const handleTosterClose = () => {
        setOpenToster(false);
    };

    const handleChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    const getImages = () => {
        if (listingData?.listing?.assets) {
            return listingData.listing.assets.filter((item) => item.fileId);
        }
        return [];
    };

    const handleSlide = () => {
        imageSliderRef?.current?.start();
    };

    const handleStopSlide = () => {
        imageSliderRef?.current?.stop();
    };

    const getRentColumns = () => {
        let columns = [
            {
                name: "year",
                label: "Year",
            },
            {
                name: "monthlyRent",
                label: "Monthly rent",
                selector: (row) => (row.monthlyRent > 0 ? formatter.format(row.monthlyRent) : "--"),
            },
        ];

        return columns.map((item) => {
            return {
                name: item.label,
                selector: item.selector ? item.selector : (row) => row[item.name],
                sortable: false,
            };
        });
    };

    const getPurchaseColumns = () => {
        let columns = [
            {
                name: "month",
                label: "Month",
            },
            {
                name: "purchasePrice",
                label: "Purchase price",
                selector: (row) =>
                    row.purchasePrice === "N/A"
                        ? row.purchasePrice
                        : row.purchasePrice > 0
                        ? formatter.format(row.purchasePrice)
                        : "--",
            },
        ];

        return columns.map((item) => {
            return {
                name: item.label,
                selector: item.selector ? item.selector : (row) => row[item.name],
                sortable: false,
            };
        });
    };

    const getUnderWritingData = () => {
        if (listingData?.listing?.relatedUW && listingData?.listing?.property?.propertyState !== "TX") {
            return [
                {
                    year: "Year 1",
                    month: "At Month 12",
                    monthlyRent: listingData?.listing?.relatedUW?.year1Rent,
                    purchasePrice: listingData?.listing?.displayYear1PurchasePrice
                        ? listingData?.listing?.relatedUW?.year1Price
                        : "N/A",
                },
                {
                    year: "Year 2",
                    month: "At Month 25",
                    monthlyRent: listingData?.listing?.relatedUW?.year2Rent,
                    purchasePrice: listingData?.listing?.relatedUW?.year2Price,
                },
                {
                    year: "Year 3",
                    month: "Up to Month 36",
                    monthlyRent: listingData?.listing?.relatedUW?.year3Rent,
                    purchasePrice: listingData?.listing?.relatedUW?.year3Price,
                },
                {
                    year: "Year 4",
                    month: "Up to Month 48",
                    monthlyRent: listingData?.listing?.relatedUW?.year4Rent,
                    purchasePrice: listingData?.listing?.relatedUW?.year4Price,
                },
                {
                    year: "Year 5",
                    month: "Up to Month 60",
                    monthlyRent: listingData?.listing?.relatedUW?.year5Rent,
                    purchasePrice: listingData?.listing?.relatedUW?.year5Price,
                },
            ];
        } else if (listingData?.listing?.relatedUW && listingData?.listing?.property?.propertyState === "TX") {
            return [
                {
                    year: "Year 1",
                    month: "At Month 12",
                    monthlyRent: listingData?.listing?.relatedUW?.year1Rent,
                    purchasePrice: listingData?.listing?.displayYear1PurchasePrice
                        ? listingData?.listing?.relatedUW?.year1Price
                        : "N/A",
                },
                {
                    year: "Year 2",
                    month: "At Month 25",
                    monthlyRent: listingData?.listing?.relatedUW?.year2Rent,
                    purchasePrice: listingData?.listing?.relatedUW?.year2Price,
                },
                {
                    year: "Year 3",
                    month: "Up to Month 36",
                    monthlyRent: listingData?.listing?.relatedUW?.year3Rent,
                    purchasePrice: listingData?.listing?.relatedUW?.year3Price,
                },
            ];
        }
        return [
            { year: 1, month: 12, monthlyRent: 0, purchasePrice: 0 },
            { year: 2, month: 24, monthlyRent: 0, purchasePrice: 0 },
            { year: 3, month: 36, monthlyRent: 0, purchasePrice: 0 },
            { year: 4, month: 48, monthlyRent: 0, purchasePrice: 0 },
            { year: 5, month: 60, monthlyRent: 0, purchasePrice: 0 },
        ];
    };

    const displayPropertyDetails = (label, value) => {
        return (
            <Grid
                container
                spacing={0}
                sx={{ borderBottom: "1px solid #e5e5e5", paddingBottom: "0.5rem" }}
                justifyContent={"space-between"}>
                <Grid>
                    <Box sx={{ p: "10px", color: "#164C63", fontSize: "14px", fontWeight: "600" }}>{label}</Box>
                </Grid>
                <Grid>
                    <Box sx={{ p: "10px", color: "#1F4E66", fontSize: "14px", fontWeight: "400" }}>
                        {value ? value : "-"}
                    </Box>
                </Grid>
            </Grid>
        );
    };

    const getBadges = (item) => {
        let promotions = listingData?.listing?.promotions?.filter(
            (promotion) => new Date(promotion.startDate) <= new Date() && new Date() <= new Date(promotion.endDate)
        );
        let openHouses = listingData?.listing?.openHouses?.filter(
            (openHouse) => new Date(openHouse.startDate) >= new Date()
        );

        let displayComingSoon = listingData?.listing?.webListingStatus === "Coming Soon";

        let higlights = listingData?.listing?.propertyHighlights?.split(";");
        return (
            <Box sx={{ position: "absolute", top: "8px", left: "5px" }}>
                {promotions?.map((promotion) => (
                    <Chip
                        sx={{
                            background: "#1570EF",
                            height: "27px",
                            color: "white",
                            marginRight: "5px",
                            fontSize: "14px",
                        }}
                        label={promotion.name}
                    />
                ))}
                {higlights?.map((higlight) => (
                    <Chip
                        sx={{
                            background: "#1570EF",
                            height: "27px",
                            color: "white",
                            marginRight: "5px",
                            fontSize: "14px",
                            mt: "3px",
                        }}
                        label={higlight}
                    />
                ))}
                {openHouses?.map((openHouse) => (
                    <Chip
                        sx={{
                            background: "#17B26A",
                            height: "27px",
                            color: "white",
                            marginRight: "5px",
                            fontSize: "14px",
                        }}
                        label={
                            "Open " + formatDateTimeRange(new Date(openHouse.startDate), new Date(openHouse.endDate))
                        }
                    />
                ))}
                {displayComingSoon && (
                    <Chip
                        sx={{
                            background: "#17B26A",
                            height: "27px",
                            color: "white",
                            marginRight: "5px",
                            fontSize: "14px",
                            mt: "3px",
                        }}
                        label={"Coming Soon"}
                    />
                )}
            </Box>
        );
    };

    const handleBackClick = () => {
        window.open("/listing-search", "_self");
    };

    const handleMapChange = (map) => {
        setMapObject(map);
    };

    const handleProfileChange = (event, newValue) => {
        setSelectedProfileTab(newValue);
    };

    const handleVirtualtourClick = () => {
        window.open(listingData?.listing.virtualTourURL);
    };

    const displayImage = (url, type, className) => {
        return (
            <>
                {type.startsWith("image") && <img className={className} src={url} alt={"image0"} />}
                {type.startsWith("video") && (
                    <video className={className}>
                        <source src={url} type="video/mp4" />
                    </video>
                )}
            </>
        );
    };

    const displayHeaderImages = () => {
        return (
            <>
                {getImages()?.length >= 3 && !isMobile && (
                    <Box sx={{ height: "400px", borderRadius: "8px", background: "transparent" }}>
                        <Grid container spacing={0}>
                            <Grid xs={8} sx={{ p: "0 6px 0 0" }}>
                                {displayImage(
                                    process.env.REACT_APP_CLOUD_FRONT_URL + getImages()[0].fileId,
                                    getImages()[0].type,
                                    "image-one"
                                )}
                            </Grid>
                            <Grid xs={4} sx={{ p: "0 0px 0 0" }}>
                                {displayImage(
                                    process.env.REACT_APP_CLOUD_FRONT_URL + getImages()[1].fileId,
                                    getImages()[1].type,
                                    "image-two"
                                )}
                                {displayImage(
                                    process.env.REACT_APP_CLOUD_FRONT_URL + getImages()[2].fileId,
                                    getImages()[2].type,
                                    "image-three"
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                )}
                {getImages()?.length > 0 && (getImages()?.length < 3 || isMobile) && (
                    <Box
                        className="imgslider"
                        sx={{ width: "100%", height: "400px" }}
                        onMouseOver={() => handleSlide()}
                        onMouseOut={() => handleStopSlide()}>
                        <ImageSlider
                            ref={imageSliderRef}
                            sx={{ height: "400px", width: "100%", objectFit: "cover" }}
                            images={getImages()?.map((item) => ({
                                url: process.env.REACT_APP_CLOUD_FRONT_URL + item.fileId,
                                type: item.type,
                                alt: "image",
                            }))}></ImageSlider>
                    </Box>
                )}
                {getImages()?.length === 0 && (
                    <Box
                        sx={{
                            minHeight: "400px",
                            background: "#ececec",
                            display: "flex",
                            justifyContent: "center",
                            justifyItems: "center",
                            alignItems: "center",
                            borderRadius: "8px",
                        }}>
                        <MapsHomeWorkIcon sx={{ width: "10rem", height: "10rem", color: "white" }}></MapsHomeWorkIcon>
                    </Box>
                )}
            </>
        );
    };

    const displayModalImage = (records) => {
        return (
            <Grid container spacing={2}>
                <Grid lg={3} sx={{ display: { xs: "none", lg: "flex" } }}>
                    <Box sx={{ p: "16px", height: "calc(100vh - 183px)", overflow: "auto" }}>
                        {records?.length > 0 && (
                            <Grid spacing={1} container>
                                {records.map((item, index) => (
                                    <Grid xs={records.length >= 3 ? ((index + 1) % 3 === 0 ? 12 : 6) : 12}>
                                        {item.type.startsWith("image") && (
                                            <img
                                                onClick={() => slider?.slickGoTo(index)}
                                                style={{
                                                    height: (index + 1) % 3 === 0 ? "200px" : "150px",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                }}
                                                className={index === currentSelectedModalImage ? "selected-img" : ""}
                                                src={process.env.REACT_APP_CLOUD_FRONT_URL + item.fileId}
                                                alt={item.alt}
                                            />
                                        )}
                                        {item.type.startsWith("video") && (
                                            <video
                                                className={index === currentSelectedModalImage ? "selected-img" : ""}
                                                style={{
                                                    height: (index + 1) % 3 === 0 ? "200px" : "150px",
                                                    width: "100%",
                                                    objectFit: "cover",
                                                    borderRadius: "6px",
                                                    cursor: "pointer",
                                                }}
                                                onClick={() => slider?.slickGoTo(index)}>
                                                <source
                                                    src={process.env.REACT_APP_CLOUD_FRONT_URL + item.fileId}
                                                    type="video/mp4"
                                                />
                                            </video>
                                        )}
                                    </Grid>
                                ))}
                            </Grid>
                        )}
                    </Box>
                </Grid>
                <Grid xs={12} lg={9}>
                    <Box>
                        <Box
                            className="imgslider"
                            sx={{
                                width: "100%",
                                height: "calc(100vh - 200px)",
                                p: "16px 16px 16px 16px",
                                borderRadius: "6px",
                            }}>
                            <ImageSlider
                                setting={{
                                    infinite: false,
                                    beforeChange: (current, next) => {
                                        setCurrentSelectedModalImage(next);
                                        setTimeout(() => {
                                            document.querySelector(".selected-img").scrollIntoView({
                                                behavior: "smooth",
                                                block: "center",
                                            });
                                        }, 500);
                                    },
                                }}
                                onLoadComplete={(slider) => setSlider(slider)}
                                sx={{
                                    height: isMobile ? "auto" : "calc(100vh - 200px)",
                                    borderRadius: "6px",
                                    maxWidth: isMobile ? "auto" : "100%",
                                    margin: "0 auto",
                                    width: isMobile ? "100%" : "auto",
                                }}
                                isMobile={isMobile || isPortrait}
                                autoPlay={true}
                                images={records?.map((item) => ({
                                    url: process.env.REACT_APP_CLOUD_FRONT_URL + item.fileId,
                                    alt: "image",
                                    type: item.type,
                                }))}></ImageSlider>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        );
    };

    const displayYear2PriceSubtitle = (listingData) => {
        const year2Price = listingData?.listing?.relatedUW?.year2Price;

        if (year2Price !== 0 && year2Price !== null && year2Price !== undefined) {
            return (
                <Grid item sx={{ pb: { xs: "1.6rem", md: "0" } }}>
                    <Typography
                        variant="subtitle1"
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            flexWrap: "wrap",
                        }}>
                        <CurrancyIcon></CurrancyIcon>
                        <span style={{ marginLeft: "7px" }}>
                            2 year price lock at ${numberFormatter.format(year2Price)}**
                        </span>
                    </Typography>
                </Grid>
            );
        }
    };

    const getVideos = () => {
        return getImages().filter((item) => item.type?.startsWith("video"));
    };

    const getFloorPlans = () => {
        if (listingData?.listing?.detailedAssetLinks) {
            return listingData.listing.detailedAssetLinks
                .filter(
                    (item) =>
                        item.tags &&
                        item.tags.length > 0 &&
                        item.tags.filter((tag) => tag.tagName === "Floor Plan").length > 0
                )
                .map((item) => item.asset);
        }
        return [];
    };

    const handleScheduleSelfTour = () => {
        if (listingData?.listing?.selfShowingURL) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(listingData?.listing?.selfShowingURL, "text/html");
            var anchorElement = doc?.querySelector("a");
            var url = anchorElement?.getAttribute("href");
            if (url) {
                window.open(url);
            }
        }
    };

    const handleSettingClick = () => {
        window.open(process.env.REACT_APP_SALESFORCE_URL + listingData?.listing?.salesforceId);
    };

    const handleApplyNowClick = () => {
        window.open(process.env.REACT_APP_APPLY_NOW + "?recordId=" + listingData?.listing?.salesforceId);
    };

    const getTotalRent = (listPrice) => {
        let total = parseFloat(listPrice) + 40 + 9.95 + 9.95 + (listingData?.listing?.hasPool === "Yes" ? 120 : 0);
        return total.toFixed(2);
    };

    const handleSelfTourWaitlist = () => {
        setOpenSelfTour(true);
    };

    const handleSelfTourWaitListClose = () => {
        setOpenSelfTour(false);
    };

    const handleComplete = (success) => {
        if (success) {
            setTosterVariant("success");
            setTosterMessage(`Thank you for your interest in this property. We will notify you as soon as tours open.`);
            setOpenToster(true);
        } else {
            setTosterVariant("error");
            setTosterMessage(
                `There was a problem with starting your application. Please contact support at (877) 958-1888.`
            );
            setOpenToster(true);
        }
    };

    let body = (
        <Box
            className="Property"
            sx={{ color: config.brandColor, overflowX: "clip", marginTop: { xs: "75px", md: "48px", lg: "0px" } }}>
            {status === "succeeded" && (
                <>
                    <TabContext value={selectedTab}>
                        <Box
                            sx={{
                                flexGrow: 1,
                                background: "white",
                                position: "fixed",
                                width: "100%",
                                zIndex: "10",
                                top: { xs: "67px", lg: "71px" },
                                borderTop: config.border,
                            }}>
                            <Box
                                className="container"
                                sx={{ width: { lg: "1120px", xs: "100%" }, padding: { xs: "0px 16px", lg: "0px" } }}>
                                <Grid container justifyContent={"start"} alignItems={"center"}>
                                    <Grid item>
                                        <Button
                                            onClick={handleBackClick}
                                            sx={{
                                                ml: "-16px",
                                                color: config.brandColor,
                                                "&:hover": { background: "transparent" },
                                            }}
                                            variant="text"
                                            startIcon={<ArrowBackIcon />}>
                                            Back to search
                                        </Button>
                                    </Grid>
                                    <Grid
                                        item
                                        sx={{
                                            marginLeft: "1rem",
                                            paddingLeft: "1rem",
                                            borderLeft: "1px solid #ebecf0",
                                        }}>
                                        <TabList onChange={handleChange} aria-label="lab API tabs example">
                                            <AntTab label="Overview" value="Overview" />
                                        </TabList>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        <Box sx={{ background: "#fafaf6" }}>
                            <TabPanel value="Overview" sx={{ padding: "64px 0px" }}>
                                <Box
                                    className="container"
                                    sx={{ width: { lg: "1120px", xs: "100%" }, padding: { xs: "16px", lg: "0px" } }}>
                                    <Paper elevation={1} sx={{ position: "relative" }}>
                                        {displayHeaderImages()}
                                        {getBadges()}

                                        <Box
                                            sx={{
                                                position: "absolute",
                                                bottom: "10px",
                                                width: "100%",
                                                paddingLeft: "0.75rem",
                                            }}>
                                            <Grid container spacing={1} sx={{ flexGrow: 1 }}>
                                                {listingData.listing.streetViewStatus?.toLowerCase() === "working" && (
                                                    <Grid>
                                                        <Button
                                                            variant="outlined"
                                                            sx={{
                                                                mt: "4px",
                                                                mr: "10px",
                                                                background: "#FFF",
                                                                color: "#1F4E66",
                                                                border: "1px solid rgb(175 175 175 / 50%)",
                                                                "&:hover": {
                                                                    background: "#FFF",
                                                                },
                                                            }}
                                                            startIcon={<StreetViewIcon />}
                                                            onClick={() => {
                                                                setPhotosModal(true);
                                                                setSelectedProfileTab("Street View");
                                                            }}>
                                                            {"Street View"}
                                                        </Button>
                                                    </Grid>
                                                )}

                                                {getVideos().length > 0 && (
                                                    <Grid>
                                                        <Button
                                                            variant="outlined"
                                                            sx={{
                                                                mt: "4px",
                                                                mr: "10px",
                                                                background: "#FFF",
                                                                color: "#1F4E66",
                                                                border: "1px solid rgb(175 175 175 / 50%)",
                                                                "&:hover": {
                                                                    background: "#FFF",
                                                                },
                                                            }}
                                                            startIcon={<VideoIcon />}
                                                            onClick={() => {
                                                                setPhotosModal(true);
                                                                setSelectedProfileTab("Videos");
                                                            }}>
                                                            {"Video"}
                                                        </Button>
                                                    </Grid>
                                                )}

                                                {listingData?.listing?.virtualTourURL && (
                                                    <Grid>
                                                        <Button
                                                            variant="outlined"
                                                            sx={{
                                                                mt: "4px",
                                                                mr: "10px",
                                                                background: "#FFF",
                                                                color: "#1F4E66",
                                                                border: "1px solid rgb(175 175 175 / 50%)",
                                                                "&:hover": {
                                                                    background: "#FFF",
                                                                },
                                                            }}
                                                            startIcon={<VirtualTourcon />}
                                                            onClick={handleVirtualtourClick}>
                                                            {"Virtual tour"}
                                                        </Button>
                                                    </Grid>
                                                )}
                                                {getFloorPlans().length > 0 && (
                                                    <Grid>
                                                        <Button
                                                            variant="outlined"
                                                            sx={{
                                                                mt: "4px",
                                                                mr: "10px",
                                                                background: "#FFF",
                                                                color: "#1F4E66",
                                                                border: "1px solid rgb(175 175 175 / 50%)",
                                                                "&:hover": {
                                                                    background: "#FFF",
                                                                },
                                                            }}
                                                            startIcon={<FloorPlanIcon />}
                                                            onClick={() => {
                                                                setPhotosModal(true);
                                                                setSelectedProfileTab("Floor Plan");
                                                            }}>
                                                            {"Floor plan"}
                                                        </Button>
                                                    </Grid>
                                                )}

                                                <Grid mdOffset="auto">
                                                    <Button
                                                        variant="outlined"
                                                        sx={{
                                                            mt: "4px",
                                                            mr: "10px",
                                                            background: "#FFF",
                                                            color: "#1F4E66",
                                                            border: "1px solid rgb(175 175 175 / 50%)",
                                                            "&:hover": {
                                                                background: "#FFF",
                                                            },
                                                        }}
                                                        startIcon={<PhotosIcon />}
                                                        onClick={() => {
                                                            getImages()?.length > 0
                                                                ? setPhotosModal(true)
                                                                : setPhotosModal(false);
                                                            setSelectedProfileTab("Photos");
                                                        }}>
                                                        {(getImages() ? getImages()?.length : 0) + " Photos"}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Box>
                                    </Paper>
                                    <Paper sx={{ mt: "16px", p: ".75rem" }} elevation={1}>
                                        <Grid container justifyContent={"space-between"} alignItems={"center"}>
                                            <Grid item>
                                                <Typography
                                                    sx={{ color: config.brandColor }}
                                                    gutterBottom
                                                    variant="h5"
                                                    component="h1">
                                                    {listingData?.listing.propertyAddress}
                                                </Typography>
                                                <Grid container spacing={3} justifyContent={"flex-start"}>
                                                    <Grid item>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                flexWrap: "wrap",
                                                            }}>
                                                            <CurrancyIcon></CurrancyIcon>
                                                            <span style={{ marginLeft: "7px" }}>
                                                                {numberFormatter.format(listingData?.listing?.listRent)}
                                                                /mo &nbsp;
                                                            </span>
                                                            <span style={{ fontSize: "14px", fontWeight: "400" }}>
                                                                *plus required fees
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    {/* {displayYear2PriceSubtitle(listingData)} */}
                                                </Grid>
                                                <Grid container spacing={3} justifyContent={"flex-start"}>
                                                    <Grid item>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                flexWrap: "wrap",
                                                            }}>
                                                            <BedIcon></BedIcon>
                                                            <span style={{ marginLeft: "7px" }}>
                                                                {listingData?.listing?.bedrooms} Beds
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                flexWrap: "wrap",
                                                            }}>
                                                            <BathIcon></BathIcon>
                                                            <span style={{ marginLeft: "7px" }}>
                                                                {listingData?.listing.baths} Baths
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                flexWrap: "wrap",
                                                            }}>
                                                            <SquareIcon></SquareIcon>
                                                            <span style={{ marginLeft: "7px" }}>
                                                                {numberFormatter.format(
                                                                    listingData?.listing.squareFeet
                                                                )}{" "}
                                                                ft
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item>
                                                        <Typography
                                                            variant="body2"
                                                            sx={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                flexWrap: "wrap",
                                                            }}>
                                                            <TurnedInNotIcon
                                                                sx={{
                                                                    width: "14px",
                                                                    color: "#068ab2",
                                                                }}></TurnedInNotIcon>
                                                            <span style={{ marginLeft: "7px" }}>
                                                                <i>{listingData?.listing.leaseType}</i>
                                                            </span>
                                                        </Typography>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid xs={12} md="auto" sx={{ mt: { xs: "16px", md: "0px" } }}>
                                                {listingData?.listing?.selfTourWorking ? (
                                                    <Button
                                                        fullWidth={isMobile ? true : false}
                                                        sx={{
                                                            marginBottom: { xs: "10px", md: "0px" },
                                                            mr: { xs: "0px", md: "10px" },
                                                        }}
                                                        size="small"
                                                        variant="contained"
                                                        onClick={handleScheduleSelfTour}>
                                                        Schedule Self-Tour
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        fullWidth={isMobile ? true : false}
                                                        sx={{
                                                            marginBottom: { xs: "10px", md: "0px" },
                                                            mr: { xs: "0px", md: "10px" },
                                                        }}
                                                        size="small"
                                                        variant="outlined"
                                                        onClick={handleSelfTourWaitlist}>
                                                        Join Self-Tour Waitlist
                                                    </Button>
                                                )}
                                                <Button
                                                    fullWidth={isMobile ? true : false}
                                                    size="small"
                                                    variant="contained"
                                                    onClick={handleApplyNowClick}>
                                                    Apply Now
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                    <Grid sx={{ mt: ".6rem" }} container spacing={3}>
                                        <Grid item xs={12} md={5}>
                                            <Card>
                                                <CardHeader
                                                    sx={{
                                                        p: ".75rem",
                                                        fontSize: "16px",
                                                        fontWeight: "600",
                                                        color: "#164C63",
                                                        borderBottom: "1px solid #ebecf0",
                                                    }}
                                                    title="About the property"
                                                    titleTypographyProps={{ component: "h2" }}></CardHeader>
                                                <CardContent>
                                                    <InnerCard title="Neighborhood">
                                                        <Map
                                                            zoom={15}
                                                            coordinates={{
                                                                lat: listingData?.listing?.propertyLat,
                                                                lng: listingData?.listing?.propertyLng,
                                                            }}
                                                            simpleMap
                                                            dimensions={{ width: "100%", height: "200px" }}
                                                            onMapChange={handleMapChange}></Map>
                                                    </InnerCard>
                                                    {listingData?.listing?.listingBody && (
                                                        <Box sx={{ mt: ".75rem" }}>
                                                            <InnerCard title="About this home">
                                                                <Typography variant="body2" color="text.secondary">
                                                                    {listingData?.listing?.listingBody}
                                                                </Typography>
                                                            </InnerCard>
                                                        </Box>
                                                    )}

                                                    <Box sx={{ mt: ".75rem" }}>
                                                        <InnerCard title="About this home">
                                                            <Grid
                                                                sx={{ margin: "-1.7rem", width: "calc(100% + 3.4rem)" }}
                                                                xs={12}>
                                                                {displayPropertyDetails(
                                                                    "Property type",
                                                                    listingData?.listing?.propertyType
                                                                )}
                                                                {displayPropertyDetails(
                                                                    "Roof type",
                                                                    listingData?.listing?.roofType
                                                                )}
                                                                {displayPropertyDetails(
                                                                    "Parking",
                                                                    listingData?.listing?.parking
                                                                )}
                                                                {displayPropertyDetails(
                                                                    "HVAC",
                                                                    listingData?.listing?.HVACType
                                                                )}
                                                                {displayPropertyDetails(
                                                                    "Year build",
                                                                    listingData?.listing?.yearBuilt
                                                                )}
                                                                {displayPropertyDetails(
                                                                    "Stories",
                                                                    listingData?.listing?.property?.numberOfStories
                                                                )}
                                                                {displayPropertyDetails(
                                                                    "Beds",
                                                                    listingData?.listing?.bedrooms
                                                                )}
                                                                {displayPropertyDetails(
                                                                    "Baths",
                                                                    listingData?.listing?.baths
                                                                )}
                                                            </Grid>
                                                        </InnerCard>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                        <Grid item md={7} xs={12}>
                                            <Card>
                                                <CardHeader
                                                    sx={{
                                                        p: ".75rem",
                                                        fontSize: "16px",
                                                        fontWeight: "600",
                                                        color: "#164C63",
                                                        borderBottom: "1px solid #ebecf0",
                                                    }}
                                                    title={
                                                        listingData?.listing.pathwayRentalProduct === "Rent to Own"
                                                            ? "Your Path to Home Ownership"
                                                            : "Rent and Fees"
                                                    }
                                                    titleTypographyProps={{ component: "h2" }}></CardHeader>
                                                <CardContent>
                                                    {/* {listingData?.listing.pathwayRentalProduct === "Rent to Own" && (
                                                        <Typography variant="body2" color="text.secondary">
                                                            Home ownership with Pathway Homes has never been easier!
                                                            You’ll have the ability to lock in your rent for up to {listingData?.listing?.property?.propertyState === 'TX' ? '3 ' : '5 '}
                                                            years and you’ll have the option to buy the home!
                                                        </Typography>
                                                    )} */}

                                                    {/* {listingData?.listing.pathwayRentalProduct === "Rent to Own" && (
                                                        <Box sx={{ mt: ".75rem" }}>
                                                            <InnerCard
                                                                title="Monthly Rent*"
                                                                subTitle={`Guaranteed prices. No Surprises. When you sign a lease with Pathway, we’ll lock in your rent for ${
                                                                    listingData?.listing?.property?.propertyState ===
                                                                    "TX"
                                                                        ? "3 "
                                                                        : "5 "
                                                                } years.`}>
                                                                <DataTable
                                                                    sx={{ overflow: "auto" }}
                                                                    columns={getRentColumns()}
                                                                    data={getUnderWritingData()}
                                                                    disableSelected
                                                                    hideHeader></DataTable>
                                                            </InnerCard>
                                                        </Box>
                                                    )} */}

                                                    <Box sx={{ mt: ".75rem" }}>
                                                        <InnerCard title="Total monthly rent">
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontSize: "20px",
                                                                        fontWeight: "600",
                                                                        color: "#088AB2",
                                                                    }}
                                                                    color={config.brandColor}>
                                                                    Total
                                                                </Typography>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{
                                                                        fontSize: "20px",
                                                                        fontWeight: "600",
                                                                        color: "#088AB2",
                                                                    }}
                                                                    color={config.brandColor}>
                                                                    $
                                                                    {floatFormatter.format(
                                                                        getTotalRent(listingData?.listing?.listRent)
                                                                    )}
                                                                    <span
                                                                        style={{
                                                                            fontSize: "14px",
                                                                            fontWeight: "400",
                                                                            color: "#475467",
                                                                        }}>
                                                                        /mo
                                                                    </span>
                                                                </Typography>
                                                            </Box>
                                                            <Divider sx={{ margin: ".65rem -1rem" }}></Divider>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ fontSize: "15px", fontWeight: "500" }}
                                                                    color={config.brandColor}>
                                                                    Base Rent
                                                                </Typography>
                                                                <Typography variant="body" color={config.brandColor}>
                                                                    $
                                                                    {numberFormatter.format(
                                                                        listingData?.listing?.listRent
                                                                    )}
                                                                </Typography>
                                                            </Box>
                                                            <Divider sx={{ margin: ".65rem -1rem" }}></Divider>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ fontSize: "15px", fontWeight: "500" }}
                                                                    color={config.brandColor}>
                                                                    Smart Home
                                                                </Typography>
                                                                <Typography variant="body" color={config.brandColor}>
                                                                    $40.00
                                                                </Typography>
                                                            </Box>
                                                            <Divider sx={{ margin: ".65rem -1rem" }}></Divider>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ fontSize: "15px", fontWeight: "500" }}
                                                                    color={config.brandColor}>
                                                                    Air Filter Delivery
                                                                </Typography>
                                                                <Typography variant="body" color={config.brandColor}>
                                                                    $9.95
                                                                </Typography>
                                                            </Box>
                                                            <Divider sx={{ margin: ".65rem -1rem" }}></Divider>
                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    justifyContent: "space-between",
                                                                }}>
                                                                <Typography
                                                                    variant="body2"
                                                                    sx={{ fontSize: "15px", fontWeight: "500" }}
                                                                    color={config.brandColor}>
                                                                    Utility Management
                                                                </Typography>
                                                                <Typography variant="body" color={config.brandColor}>
                                                                    $9.95
                                                                </Typography>
                                                            </Box>
                                                            {listingData?.listing?.hasPool === "Yes" && (
                                                                <>
                                                                    <Divider sx={{ margin: ".65rem -1rem" }}></Divider>
                                                                    <Box
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "space-between",
                                                                        }}>
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{ fontSize: "15px", fontWeight: "500" }}
                                                                            color={config.brandColor}>
                                                                            Pool Fee
                                                                        </Typography>
                                                                        <Typography
                                                                            variant="body"
                                                                            color={config.brandColor}>
                                                                            $120.00
                                                                        </Typography>
                                                                    </Box>
                                                                </>
                                                            )}

                                                            <Divider sx={{ margin: ".65rem -1rem" }}></Divider>
                                                            <Box>
                                                                <Typography variant="body" color={config.brandColor}>
                                                                    Estimated total monthly rent does not include
                                                                    utilities or optional and conditional fees
                                                                    including, but not limited to, pet fees
                                                                </Typography>
                                                            </Box>
                                                        </InnerCard>
                                                    </Box>

                                                    {listingData?.listing.pathwayRentalProduct === "Rent to Own" && (
                                                        <Box sx={{ mt: ".75rem" }}>
                                                            <InnerCard
                                                                hideContent
                                                                title="Pathway Gives you Options"
                                                                subTitle={`With Rent+, you have the option to purchase this home. At the end of the program, you can buy based on the fair market value.*`}>
                                                                {/* <DataTable
                                                                    sx={{ overflow: "auto" }}
                                                                    columns={getPurchaseColumns()}
                                                                    data={getUnderWritingData()?.slice(1)}
                                                                    disableSelected
                                                                    hideHeader></DataTable> */}
                                                            </InnerCard>
                                                        </Box>
                                                    )}

                                                    <Box sx={{ mt: ".75rem" }}>
                                                        <InnerCard
                                                            title="Upfront costs"
                                                            subTitle="Here’s a breakout of all the costs due prior to move-in.">
                                                            <Box sx={{ display: "flex", alignItems: "start" }}>
                                                                <Box sx={{ display: { xs: "none", md: "block" } }}>
                                                                    <Box
                                                                        sx={{
                                                                            width: "44px",
                                                                            height: "44px",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            borderRadius: "8px",
                                                                            border: "1px solid #E4E4D4",
                                                                            marginRight: "1rem",
                                                                            display: "flex",
                                                                        }}>
                                                                        <UserCheckIcon />
                                                                    </Box>
                                                                </Box>
                                                                <Box sx={{ pr: "20px" }}>
                                                                    <Typography
                                                                        variant="body2"
                                                                        color={config.brandColor}>
                                                                        <b>Hold fee</b>
                                                                    </Typography>
                                                                    <Typography variant="body2" color="text.secondary">
                                                                        Once approved, we collect a small fee to reserve
                                                                        the home for you ahead of move-in. This amount
                                                                        goes toward first month’s rent.
                                                                    </Typography>
                                                                </Box>
                                                                <Box>
                                                                    <Button
                                                                        variant="outlined"
                                                                        sx={{ mt: "4px", mr: "10px" }}>
                                                                        {formatter.format(1000)}
                                                                    </Button>
                                                                </Box>
                                                            </Box>

                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "start",
                                                                    justifyContent: "space-between",
                                                                    mt: "1rem",
                                                                }}>
                                                                <Box sx={{ display: "flex" }}>
                                                                    <Box sx={{ display: { xs: "none", md: "block" } }}>
                                                                        <Box
                                                                            sx={{
                                                                                width: "44px",
                                                                                height: "44px",
                                                                                justifyContent: "center",
                                                                                alignItems: "center",
                                                                                borderRadius: "8px",
                                                                                border: "1px solid #E4E4D4",
                                                                                marginRight: "1rem",
                                                                                display: "flex",
                                                                            }}>
                                                                            <LockIcon />
                                                                        </Box>
                                                                    </Box>
                                                                    <Box sx={{ pr: "20px" }}>
                                                                        <Typography
                                                                            variant="body2"
                                                                            color={config.brandColor}>
                                                                            <b>Security deposit</b>
                                                                        </Typography>
                                                                        <Typography
                                                                            variant="body2"
                                                                            color="text.secondary">
                                                                            Equal to one month of rent. Due when you
                                                                            sign your lease.
                                                                        </Typography>
                                                                    </Box>
                                                                </Box>

                                                                <Box>
                                                                    <Button
                                                                        variant="outlined"
                                                                        sx={{ mt: "4px", mr: "10px" }}>
                                                                        {formatter.format(
                                                                            listingData?.listing?.listRent
                                                                        )}
                                                                    </Button>
                                                                </Box>
                                                            </Box>

                                                            <Box
                                                                sx={{
                                                                    display: "flex",
                                                                    alignItems: "start",
                                                                    mt: "1rem",
                                                                }}>
                                                                <Box sx={{ display: { xs: "none", md: "block" } }}>
                                                                    <Box
                                                                        sx={{
                                                                            width: "44px",
                                                                            height: "44px",
                                                                            justifyContent: "center",
                                                                            alignItems: "center",
                                                                            borderRadius: "8px",
                                                                            border: "1px solid #E4E4D4",
                                                                            marginRight: "1rem",
                                                                            display: "flex",
                                                                        }}>
                                                                        <RentIcon />
                                                                    </Box>
                                                                </Box>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "space-between",
                                                                        width: "100%",
                                                                    }}>
                                                                    <Box sx={{ pr: "20px" }}>
                                                                        <Typography
                                                                            variant="body2"
                                                                            color={config.brandColor}>
                                                                            <b>Rent*</b>
                                                                        </Typography>
                                                                        <Typography
                                                                            variant="body2"
                                                                            color="text.secondary">
                                                                            We’ll prorate this amount to match the start
                                                                            date of your lease.
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box>
                                                                        <Button
                                                                            variant="outlined"
                                                                            sx={{ mt: "4px", mr: "10px" }}>
                                                                            {formatter.format(
                                                                                listingData?.listing?.listRent
                                                                            )}
                                                                        </Button>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                        </InnerCard>
                                                    </Box>

                                                    <Box sx={{ mt: ".75rem" }}>
                                                        <InnerCard
                                                            title="Alert - Beware of Scams"
                                                            subTitle={
                                                                <Box>
                                                                    <p>
                                                                        We do not advertise our homes on Craigslist,
                                                                        Offer Up, Facebook marketplace, etc. Do not wire
                                                                        funds, use Pay Pal, or pay anyone through a Cash
                                                                        App for your Security Deposit or rent. Payment
                                                                        of App fees, security deposit, and move‐in funds
                                                                        are paid directly through our website. The only
                                                                        way to lease this home is through{" "}
                                                                        <a href="https://www.yourpathway.com">
                                                                            www.yourpathway.com
                                                                        </a>
                                                                    </p>
                                                                    <p style={{ marginTop: "1rem" }}>
                                                                        Signs of a scam: Deals “too good to be true,”
                                                                        Eager request for cash or wire payments,
                                                                        email/paper applications, Acting as the “owner,”
                                                                        Bad Grammar, Home listed on Facebook
                                                                        marketplace, or Craigslist.
                                                                    </p>
                                                                </Box>
                                                            }
                                                            hideContent></InnerCard>
                                                    </Box>

                                                    <Box sx={{ mt: ".75rem" }}>
                                                        <InnerCard
                                                            title=""
                                                            subTitle={
                                                                <Box>
                                                                    <p>
                                                                        *Option price is determined by a third-party
                                                                        appraisal process and will be the greater of
                                                                        that appraisal price or the minimum Pathway
                                                                        price.
                                                                    </p>
                                                                </Box>
                                                            }
                                                            hideContent></InnerCard>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                    {process.env.REACT_APP_DISPLAY_SETTING_BUTTON === "yes" && (
                                        <Grid container justifyContent={"end"} sx={{ mt: "10px" }}>
                                            <Grid item>
                                                <Button
                                                    sx={{
                                                        marginBottom: { xs: "10px", md: "0px" },
                                                        mr: { xs: "0px", md: "10px" },
                                                        color: "#e3e3e3",
                                                        opacity: ".18",
                                                    }}
                                                    size="small"
                                                    onClick={handleSettingClick}>
                                                    <BuildIcon fontSize="small"></BuildIcon>
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    )}
                                </Box>
                            </TabPanel>
                        </Box>
                    </TabContext>
                </>
            )}
            <SelfTourWaitlist
                listing={listingData?.listing}
                open={openSelfTour}
                onClose={handleSelfTourWaitListClose}
                onComplete={handleComplete}></SelfTourWaitlist>
            <Modal
                open={photosModal}
                title="Profile"
                hideActions
                fullWidth
                hideTitle
                fullScreen={isMobile || isTablet ? true : false}>
                <Box
                    sx={{
                        height: "calc(100vh - 70px)",
                        overflow: isMobile || isTablet ? "hidden" : "auto",
                        margin: "-16px",
                    }}>
                    <TabContext value={selectedProfileTab}>
                        <Box sx={{ borderBottom: config.border, position: "relative" }}>
                            <TabList onChange={handleProfileChange} aria-label="lab API tabs example">
                                {getImages()?.length > 0 && <AntTab label="Photos" value="Photos" />}
                                {listingData?.listing?.streetViewStatus?.toLowerCase() === "working" && (
                                    <AntTab label="Street View" value="Street View" />
                                )}
                                {getVideos().length > 0 && <AntTab label="Videos" value="Videos" />}
                                {getFloorPlans().length > 0 && <AntTab label="Floor Plan" value="Floor Plan" />}
                            </TabList>
                            <Box
                                sx={{ position: "absolute", right: "10px", top: "10px" }}
                                onClick={() => setPhotosModal(false)}>
                                <CloseIcon></CloseIcon>
                            </Box>
                        </Box>
                        <Box>
                            <TabPanel value="Street View" sx={{ padding: "0px 0px", height: "calc(100vh - 118px)" }}>
                                {mapObject && (
                                    <Streetview
                                        apiKey={process.env.REACT_APP_GOOGLE_MAP_API_KEY}
                                        googleMaps={mapObject}
                                        streetViewPanoramaOptions={{
                                            position: {
                                                lat: listingData?.listing?.propertyLat,
                                                lng: listingData?.listing?.propertyLng,
                                            },
                                        }}></Streetview>
                                )}
                            </TabPanel>
                            <TabPanel value="Photos" sx={{ padding: "0px 0px" }}>
                                {displayModalImage(getImages())}
                            </TabPanel>
                            {getVideos().length > 0 && (
                                <TabPanel value="Videos" sx={{ padding: "0px 0px" }}>
                                    {displayModalImage(getVideos())}
                                </TabPanel>
                            )}
                            {getFloorPlans().length > 0 && (
                                <TabPanel value="Floor Plan" sx={{ padding: "0px 0px" }}>
                                    {displayModalImage(getFloorPlans())}
                                </TabPanel>
                            )}
                        </Box>
                    </TabContext>
                </Box>
            </Modal>
            <Snackbar
                anchorOrigin={{ vertical: "top", horizontal: "center" }}
                open={openToster}
                autoHideDuration={6000}
                sx={{ zIndex: 999900 }}
                onClose={handleTosterClose}>
                <Alert onClose={handleTosterClose} severity={tosterVariant} variant="filled">
                    {tosterMessage}
                </Alert>
            </Snackbar>
        </Box>
    );

    return getPageContent(body, status, error);
};

export { Property };
